exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Config-54012ed3{display:flex;flex-direction:row}.side-81eadd39{width:360px;padding:30px 20px;background:#fff}.main-3f201388{flex-grow:1}\n", ""]);

// Exports
exports.locals = {
	"Config": "Config-54012ed3",
	"side": "side-81eadd39",
	"main": "main-3f201388"
};